var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreditcard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18.5,
    height: 13.5,
    rx: 4,
    fill: "#FA532E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.88869C2 8.88233 2 8.87598 2 8.86962C2.02215 8.21812 2 7.33973 2 7.33973C2 5.95182 3.05206 5.16913 3.7276 5.06743C4.39944 4.96256 5.8834 5.0293 6.56632 5.06743C9.46886 5.06743 12.2813 5.13735 15.3489 5.06743C16.6483 5.03883 17.9514 4.97527 19.2545 5.01023C20.2918 5.03565 21.9418 4.9276 22.37 5.96682C22.5177 6.33547 22.5066 6.7359 22.4919 7.1268C22.3442 10.7625 22.2002 14.4013 22.0563 18.037C22.0452 18.3453 22.0157 18.6789 21.772 18.9014C21.5099 19.1334 21.0928 19.1588 20.7163 19.1684C14.917 19.3177 10.1287 19.347 4.32575 19.4995C4.14487 19.5027 3.49718 19.4995 2.83198 19.1582C2.54774 19.0216 2.08509 18.7678 2.08509 18.2327C2.08509 16.8445 2.08509 14.0681 2 8.88869Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5L22 9",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93362 16.5L5 16.5",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 16.5L10 16.5",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditcard);
export default __webpack_public_path__ + "static/media/icon-credit card.b0cac5d306102aa93e9762a05fe1b797.svg";
export { ForwardRef as ReactComponent };